<template>
  <div
    v-if="slides.length > 0"
    class="radio radio--help d-flex align-items-center justify-content-center"
    :class="{ opened: show == true }"
  >
    <div class="radio--help__minimize">
      <img src="@/assets/icons/actions/ico-ico-minimize.svg" @click="hide" />
    </div>
    <div style="gap: 2%" class="d-flex align-items-center">
      <img v-if="slides.length > 1" src="@/assets/icons/arrow-left.svg" class="arrow p-6 mr-0 hidden-lg cursor-pointer" @click="prevSlide" />
      <div class="radio--help__slide d-flex flex-column flex-sm-row">
        <img src="@/assets/icons/radio/img-pan-radio-points.svg" />
        <div class="radio--help__contents-wrapper d-flex">
          <div v-for="slide in slides" :key="slide.id">
            <div
              v-if="slide.id === slideActive.id"
              class="radio--help__content active mt-3 mt-sm-0"
            >
              <div class="d-flex align-items-center">
                <div>
                  <p
                    class="font-weight-bold radio--help__title"
                    v-html="slide.nadpis"
                  />
                  <div
                    class="font-weight-light radio--help__text"
                    v-html="slide.text"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <img v-if="slides.length > 1" src="@/assets/icons/arrow-right.svg" class="arrow p-6 mr-0 cursor-pointer" @click="nextSlide" />
    </div>
    <div
      class="radio--tutorial__paginator d-flex align-items-center justify-content-center"
    >
      <div
        v-for="(slide, index) in slides"
        :key="slide.index"
        class="radio--tutorial__page cursor-pointer"
        :class="{ active: slide.id == slideActive.id }"
        @click="toSlide(index)"
      />
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: ["show", "articleLink"],
  data() {
    return {
      radioSlides: [],
      slides: [],
      slideActive: {}
    };
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    }
  },
  watch: {
    locale() {
      this.loadSlides();
    },
    articleLink() {
      this.loadSlides();
    },
    slides() {
      this.setActive();
    }
  },
  mounted() {
    this.loadSlides();
    this.setActive();
  },
  methods: {
    loadSlides() {
      axios
        .get(
          process.env.VUE_APP_APICMS +
            "/" +
            this.locale +
            "/article" +
            this.articleLink,
          {
            crossdomain: true
          }
        )
        .then(response => {
          if (typeof response.data == "object") {
            this.slides = response.data;
            this.radioSlides = true;
          } else {
            this.slides = [];
            this.radioSlides = true;
          }
          this.$emit("changeRadioBtnVisibility", this.slides);
        })
        .catch(() => {
          this.slides = [];
          this.radioSlides = false;
          this.$emit("changeRadioBtnVisibility", this.slides);
        });
    },
    toSlide(index) {
      this.slideActive = this.slides[index];
    },
    nextSlide() {
      const index = this.slides.findIndex(slide => slide.id === this.slideActive.id)
      this.slideActive = this.slides[index + 1] || this.slides[0]
    },
    prevSlide() {
      const index = this.slides.findIndex(slide => slide.id === this.slideActive.id)
      this.slideActive = this.slides[index - 1] || this.slides[this.slides.length - 1]
    },
    setActive() {
      this.slideActive = this.slides[0];
    },
    hide() {
      this.$emit("updateShowRadioHelp", false);
    }
  }
};
</script>

<style lang="scss" scoped></style>
